export default __webpack_public_path__ + "static/media/arrowDownDark.3416abbc.svg";